// Energy units data for conversion routes
// Base unit: joule (J)

export const energyUnits = [
  { id: 'joule', name: 'Joule', symbol: 'J', plural: 'Joules', factor: 1 },
  { id: 'kilojoule', name: 'Kilojoule', symbol: 'kJ', plural: 'Kilojoules', factor: 1000 },
  { id: 'megajoule', name: 'Megajoule', symbol: 'MJ', plural: 'Megajoules', factor: 1000000 },
  { id: 'calorie', name: 'Calorie', symbol: 'cal', plural: 'Calories', factor: 4.184 },
  { id: 'kilocalorie', name: 'Kilocalorie', symbol: 'kcal', plural: 'Kilocalories', factor: 4184 },
  { id: 'watt-hour', name: 'Watt-hour', symbol: 'Wh', plural: 'Watt-hours', factor: 3600 },
  { id: 'kilowatt-hour', name: 'Kilowatt-hour', symbol: 'kWh', plural: 'Kilowatt-hours', factor: 3600000 },
  { id: 'electronvolt', name: 'Electronvolt', symbol: 'eV', plural: 'Electronvolts', factor: 1.602176634e-19 },
  { id: 'btu', name: 'British thermal unit', symbol: 'BTU', plural: 'British thermal units', factor: 1055.06 },
  { id: 'therm', name: 'Therm', symbol: 'thm', plural: 'Therms', factor: 105506000 },
  { id: 'foot-pound', name: 'Foot-pound', symbol: 'ft·lb', plural: 'Foot-pounds', factor: 1.355818 },
  { id: 'erg', name: 'Erg', symbol: 'erg', plural: 'Ergs', factor: 1e-7 },
];

// Popular conversions matching common usage
export const popularEnergyConversions = [
  { from: 'kilocalorie', to: 'joule' },
  { from: 'joule', to: 'kilocalorie' },
  { from: 'kilocalorie', to: 'kilojoule' },
  { from: 'kilojoule', to: 'kilocalorie' },
  { from: 'calorie', to: 'joule' },
  { from: 'joule', to: 'calorie' },
  { from: 'kilowatt-hour', to: 'joule' },
  { from: 'joule', to: 'kilowatt-hour' },
  { from: 'btu', to: 'joule' },
  { from: 'joule', to: 'btu' },
  { from: 'kilowatt-hour', to: 'kilojoule' },
  { from: 'kilojoule', to: 'kilowatt-hour' },
  { from: 'btu', to: 'kilocalorie' },
  { from: 'kilocalorie', to: 'btu' },
  { from: 'watt-hour', to: 'joule' },
  { from: 'joule', to: 'watt-hour' },
  { from: 'megajoule', to: 'kilowatt-hour' },
  { from: 'kilowatt-hour', to: 'megajoule' },
];

// Get unit by ID
export const getUnitById = (id) => {
  return energyUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertEnergy = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Convert to joules first, then to target unit
  const joules = value * fromUnit.factor;
  return joules / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertEnergy(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online energy unit converter.`;
};
